module.exports = __webpack_public_path__ + "img/feature_ca.ff9ee289.gif";